if (!customElements.get('faq-search')) {
  customElements.define(
    'faq-search',
    class FaqSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-faq-search-input]');
        this.clearButton = this.querySelector('[data-faq-search-clear]');
        this.emptyMessage = this.querySelector('[data-faq-search-empty]');
        this.list = this.querySelector('[data-faq-search-list]');

        if (!this.input || !this.list) return;

        this.items = Array.from(this.list.querySelectorAll('[data-faq-search]'));
        this.categories = Array.from(this.list.querySelectorAll('.faq-page__category'));

        this.input.addEventListener('input', this.onInput.bind(this));
        this.clearButton?.addEventListener('click', this.onClear.bind(this));
      }

      onInput() {
        const query = this.input.value.trim().toLowerCase();
        this.toggleClearButton(query.length > 0);
        this.filter(query);
      }

      onClear(event) {
        event.preventDefault();
        this.input.value = '';
        this.toggleClearButton(false);
        this.filter('');
        this.input.focus();
      }

      toggleClearButton(show) {
        if (!this.clearButton) return;
        this.clearButton.hidden = !show;
      }

      filter(query) {
        let visibleCount = 0;

        this.items.forEach((item) => {
          const matches = !query || (item.dataset.faqSearch || '').includes(query);
          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        this.categories.forEach((category) => {
          const hasVisibleItem = category.querySelector('.accordion-item:not([hidden])');
          category.hidden = !hasVisibleItem;
        });

        if (this.emptyMessage) {
          this.emptyMessage.hidden = visibleCount > 0 || !query;
        }
      }
    }
  );
}
